var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrientation = function SvgOrientation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.816,
    height: 15.813,
    x: 2,
    y: 2,
    stroke: "#000",
    strokeWidth: 4,
    rx: 0.748
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M12.078 11.184h9.174c.413 0 .748.335.748.748v9.32a.75.75 0 0 1-.748.748H6.935a.75.75 0 0 1-.748-.748v-4.168"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.603 9.41c.11-.05 1.748-1.675 1.81-1.795.08-.15.036-.43-.088-.561-.14-.15-.42-.203-.597-.114-.047.023-.25.205-.451.404l-.367.362-.011-.695c-.01-.635-.017-.72-.075-.989a4.42 4.42 0 0 0-1.474-2.454c-1.046-.874-2.356-1.197-3.597-.97a.4.4 0 0 0-.268.19l-.01.017a.543.543 0 0 0 .217.761.44.44 0 0 0 .275.039 3.28 3.28 0 0 1 2.371.492 3.36 3.36 0 0 1 1.37 1.758c.131.388.161.607.174 1.267l.012.59-.37-.365c-.205-.2-.41-.384-.457-.407-.208-.104-.496-.025-.638.177a.53.53 0 0 0-.043.5c.072.137 1.71 1.756 1.823 1.803.12.05.276.046.394-.01"
  })));
};
export default SvgOrientation;